<div class="main-page" *ngIf="homeItems">
  <div
    *ngFor="let module of homeItems.modules; let moduleIndex = index"
    class="template-item"
  >
    <div>
      <ng-container [ngSwitch]="module.display_type">
        <!-- Grid View -->
        <ng-container *ngSwitchCase="displayTypes.GRID">
          <div class="module-container">
            <module-header
              [title]="module.title"
              [icon]="module.icon"
            ></module-header>
            <div class="grid">
              <product-card
                *ngFor="
                  let item of module.templates | slice: 0 : itemLimit;
                  let itemIndex = index
                "
                [rowType]="module.row_type"
                [product]="item"
                [homeIndexData]="{ moduleIndex, itemIndex }"
              >
              </product-card>
            </div>
          </div>
        </ng-container>
        <!-- ----- -->

        <!-- Featured View -->
        <ng-container *ngSwitchCase="displayTypes.FEATURED">
          <div class="featured-view">
            <div class="bg-container"></div>
            <div class="featured-main">
              <module-header
                [title]="module.title"
                [icon]="module.icon"
                theme="dark"
              ></module-header>
              <div class="slider-container">
                <ngx-slick-carousel
                  class="slider-main"
                  [config]="featuredSliderConfig"
                >
                  <product-card
                    ngxSlickItem
                    class="slick-slide"
                    *ngFor="
                      let item of module.templates | slice: 0 : itemLimit;
                      let itemIndex = index
                    "
                    [rowType]="module.row_type"
                    [product]="item"
                    [expandMode]="true"
                    [homeIndexData]="{ moduleIndex, itemIndex }"
                  >
                  </product-card>
                </ngx-slick-carousel>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- ----- -->

        <!-- BLACK FRIDAY Featured View -->
        <ng-container *ngSwitchCase="displayTypes.BLACK_FRIDAY_FEATURED">
          <div class="featured-view black-friday">
            <div class="bg-container"></div>
            <div class="featured-main">
              <module-header
                [title]="module.title"
                [icon]="module.icon"
                navigationUrl="/category/67/Black-Friday"
                theme="dark"
              ></module-header>
              <div class="slider-container">
                <ngx-slick-carousel
                  class="slider-main"
                  [config]="blackFridayFeaturedSliderConfig"
                >
                  <product-card
                    ngxSlickItem
                    class="slick-slide"
                    *ngFor="
                      let item of module.templates | slice: 0 : itemLimit;
                      let itemIndex = index
                    "
                    [rowType]="module.row_type"
                    [product]="item"
                    [expandMode]="false"
                    [isBlackFriday]="true"
                    [homeIndexData]="{ moduleIndex, itemIndex }"
                  >
                  </product-card>
                </ngx-slick-carousel>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- ----- -->

        <!-- Row Slider View -->
        <ng-container *ngSwitchCase="displayTypes.BLACK_FRIDAY_ANIMATED_BAR">
          <shared-animated-bar></shared-animated-bar>
        </ng-container>
        <!-- ----- -->

        <!-- Row Slider View -->
        <ng-container *ngSwitchCase="displayTypes.ROW_SLIDER">
          <ng-container *ngIf="!isDesktopBreakpoint">
            <div class="row-slider-view">
              <ngx-slick-carousel
                class="slider-main"
                [config]="rowSliderConfig"
              >
                <a
                  *ngFor="let item of module.templates"
                  [routerLink]="[
                    '/category',
                    item.extra_info.id,
                    getUrlFriendlyName(item.title),
                  ]"
                >
                  <div ngxSlickItem class="category-item">
                    <div class="image-container">
                      <img [src]="item.image" [alt]="item.title" />
                    </div>
                    <div class="title-container">
                      <h3 class="category-title">{{ item.title }}</h3>
                    </div>
                  </div>
                </a>
              </ngx-slick-carousel>
            </div>
          </ng-container>
          <ng-container *ngIf="isDesktopBreakpoint">
            <div class="module-container category-container">
              <module-header
                [title]="module.title"
                [icon]="module.icon"
              ></module-header>
              <div class="category-grid">
                <a
                  *ngFor="let item of module.templates"
                  [routerLink]="[
                    '/category',
                    item.extra_info.id,
                    getUrlFriendlyName(item.title),
                  ]"
                >
                  <div class="category-item">
                    <div class="image-container">
                      <img [src]="item.image" [alt]="item.title" />
                    </div>
                    <div class="title-container">
                      <h3 class="category-title">{{ item.title }}</h3>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- ----- -->

        <!-- Banner View -->
        <ng-container *ngSwitchCase="displayTypes.BANNER">
          <div class="banner-view">
            <ngx-slick-carousel class="slider-main" [config]="bannerConfig">
              <a
                ngxSlickItem
                class="banner-item"
                *ngFor="let item of module.templates"
                [href]="item.link"
              >
                <div class="banner-image-container">
                  <img [src]="item.image" [alt]="item.title" />
                </div>
              </a>
            </ngx-slick-carousel>
          </div>
        </ng-container>
        <!-- ----- -->

        <!-- List View -->
        <ng-container *ngSwitchCase="displayTypes.LIST">
          <div class="module-container">
            <module-header
              [title]="module.title"
              [icon]="module.icon"
            ></module-header>
            <div class="list">
              <product-list-item
                *ngFor="
                  let item of module.templates | slice: 0 : itemLimit;
                  let itemIndex = index
                "
                [rowType]="module.row_type"
                [product]="item"
                [homeIndexData]="{ moduleIndex, itemIndex }"
              >
              </product-list-item>
            </div>
          </div>
        </ng-container>

        <!-- ----- -->
      </ng-container>
    </div>
  </div>
  <div class="module-container">
    <app-faq model="homepage"></app-faq>
  </div>
</div>
